import React, { useEffect, useState } from 'react';
import {
    Container,
    defaultStyle,
    GlobalStyle,
} from './style';
import Intro from './intro/component';

import { ReactComponent as LinkedIn } from '../assets/icons/linkedin.svg';
import { ReactComponent as GitHub } from '../assets/icons/github.svg';

import logoImg from '../assets/logo.png';
import appConstants from './domain/config';

const introTimeMs = 6000;
const maxCoreWidth = 600;

const App: React.FC = () => {
    const [time, setTime] = useState(Date.now());
    const [originalTime] = useState(Date.now());

    // eslint-disable-next-line max-len
    const calcIntroPerc = (_time: number, _originalTime: number) => (_time - _originalTime) / introTimeMs;

    useEffect(() => {
        const interval = setInterval(() => {
            if (calcIntroPerc(Date.now(), originalTime) >= 1.2) {
                clearInterval(interval);
            }
            setTime(Date.now());
        }, 30);
        return () => {
            clearInterval(interval);
        };
    }, []);

    const introPerc = calcIntroPerc(time, originalTime);
    const textOpacity = Math.min((introPerc - 1) * 5, 1);

    const windowWidth = window.outerWidth;
    const coreWidth = Math.min(windowWidth * 0.9, maxCoreWidth);

    const minPadding = (windowWidth - Math.min(windowWidth, maxCoreWidth)) / 2;

    const defaultPadding: React.CSSProperties = {
        marginLeft: (windowWidth - coreWidth) / 2,
        marginRight: (windowWidth - coreWidth) / 2,
        width: coreWidth,
    };

    return (
        <>
            <GlobalStyle />
            <Container style={{ display: 'block' }}>
                <Intro perc={Math.min(introPerc, 1)} />
                <div style={{
                    position: 'fixed',
                    top: '9%',
                    color: 'white',
                    opacity: textOpacity,
                    textAlign: 'center',
                }}
                >

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignContent: 'center',
                        justifyContent: 'center',
                        ...defaultPadding,
                    }}
                    >
                        <img
                            src={logoImg}
                            alt="logo"
                            height="40em"
                            width="auto"
                            style={{ border: '0.5px solid black', borderRadius: '20%', boxShadow: '0px 0px 10px -5px black' }}
                        />
                        <h1 style={{
                            paddingLeft: 15,
                            paddingTop: '0.5em',
                            fontSize: '1.2em',
                            fontWeight: 800,
                        }}
                        >
                            Dillenburg Services
                        </h1>
                    </div>

                    <h1 style={{
                        paddingTop: 40, fontSize: '2em', ...defaultPadding, fontWeight: 800,
                    }}
                    >
                        Quality app Design and Development
                    </h1>
                    <div style={{
                        paddingTop: 20, fontSize: '1em', fontWeight: 300, ...defaultPadding,
                    }}
                    >
                        <p>
                            {/* eslint-disable-next-line max-len */}
                            Bring the experience your small businesses clients deserve with agile development. We develop professional applications with long-term support with agile development.
                        </p>
                    </div>

                    {window.innerHeight > 790 && (
                        <>

                            <div style={{
                                marginTop: 40,
                                display: 'flex',
                                justifyContent: 'end',
                                marginRight: minPadding,
                            }}
                            >
                                <div style={{
                                    backgroundColor: defaultStyle.colors.blue,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    paddingTop: 7,
                                    paddingBottom: 7,
                                    textAlign: 'right',
                                    border: `10px ${defaultStyle.colors.red}`,
                                    fontSize: '.75em',
                                }}
                                >
                                    {/* eslint-disable-next-line max-len */}
                                    <span style={{ fontWeight: 200 }}> Master in Computer Science </span>
                                    {/* eslint-disable-next-line max-len */}
                                    <span style={{ fontWeight: 500 }}> - Universidade de São Paulo </span>
                                </div>
                            </div>
                            <div style={{
                                marginTop: 6,
                                marginRight: minPadding + 5,
                                display: 'flex',
                                justifyContent: 'end',
                                height: '1em',
                                gap: '.3em',
                            }}
                            >
                                <a href={appConstants.url.linkedin} target="_blank" rel="noreferrer">
                                    <LinkedIn height="100%" width="auto" />
                                </a>
                                <a href={appConstants.url.github} target="_blank" rel="noreferrer">
                                    <GitHub height="100%" width="auto" />
                                </a>
                            </div>
                        </>
                    )}

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '3em',
                        ...defaultPadding,
                    }}
                    >
                        <a
                            href={appConstants.url.emailQuota}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <div style={{
                                padding: '1.2em 4em',
                                backgroundColor: defaultStyle.colors.red,
                                borderRadius: '0.7em',
                                boxShadow: '0px 0px 8px -4px black',
                                cursor: 'pointer',
                                textDecoration: 'none',
                            }}
                            >
                                <span style={{ fontSize: '1em', fontWeight: 800 }}>GET A QUOTA</span>
                            </div>
                        </a>
                    </div>
                </div>
            </Container>
        </>
    );
};

export default App;
